import { render, staticRenderFns } from "./HospitalAnnouncementSetting.vue?vue&type=template&id=675f1e48"
import script from "./HospitalAnnouncementSetting.vue?vue&type=script&lang=ts"
export * from "./HospitalAnnouncementSetting.vue?vue&type=script&lang=ts"
import style0 from "./HospitalAnnouncementSetting.vue?vue&type=style&index=0&id=675f1e48&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports